<template>
  <div class="bg-stone-75">
    <Banner
      compact
      :hide-button="!content?.callToAction?.label"
      :text="content?.mainMediaBlock?.title"
      :call-to-action-link="content?.callToAction?.url"
      :description="content?.mainMediaBlock?.subtitle"
      :action-label="content?.callToAction?.label"
      :list-items="listItems"
      :featured-media="featuredMedia"
      :action="
        (event: MouseEvent) => handleCTA(content?.callToAction?.url, event)
      "
    />
  </div>
</template>
<script setup lang="ts">
const { content = {} } = defineProps<{ content: any }>()
const { toggleDateRequestSidebar } = useUiState()
const { openFromCtaClick: openHubspotFormFromCta } =
  useHubspotFormSidebarUiState()
const route = useRoute()
const emit = defineEmits(['openContactForm', 'openCaseStudyForm'])

const listItems = computed(
  () =>
    content?.listItems
      ?.map((item: { text?: string }) => item?.text)
      .filter(Boolean) ?? []
)

const featuredMedia = computed(() => {
  const url = content?.mainMediaBlock?.media?.url
  if (!url) return []
  return [
    {
      src: url,
      alt: strapiImageGetters.getAlternativeText(
        content?.mainMediaBlock?.media?.data
      ),
    },
  ]
})
const handleCTA = (action: string, event?: MouseEvent) => {
  if (openHubspotFormFromCta(action, content?.callToAction?.label, event)) {
    return
  }

  if (action === 'openEventRequestForm') {
    toggleDateRequestSidebar(route.name?.toString(), 'strapi_component')
  } else if (action === 'openPartnerContactForm') {
    emit('openContactForm')
  } else if (action === 'openCaseStudyForm') {
    emit('openCaseStudyForm')
  }
}
</script>

<style scoped lang="css"></style>
